import { ChatMessage } from '../models/chat.models';

/**
 * Reads the quick replies of a clarifying question (DATA-1560), from a `complete` event or from a
 * stored message's `metadata`. Undefined when the turn is an ordinary answer or offers no choices.
 */
export function readClarificationOptions(clarification: boolean | undefined, options: string[] | undefined): string[] | undefined {
  return clarification === true && options?.length ? options : undefined;
}

/**
 * The quick replies to show now: only those of the last message, and only when it is the assistant's
 * question. Any later message is the user's reply, so the chips go away without a flag to clear.
 */
export function pendingClarificationOptions(messages: ChatMessage[]): string[] {
  const lastMessage = messages.at(-1);
  if (lastMessage?.role !== 'assistant') {
    return [];
  }

  return lastMessage.clarificationOptions ?? [];
}
